import { createApp } from 'vue';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';
import LeadGenerationFormBlock from './LeadGenerationFormBlock.vue';

async function mountLeadGenerationFormBlock() {
	const leadGenerationForms = [
		...document.querySelectorAll('[data-feature="lead-generation-form-block"]'),
	];
	if (!leadGenerationForms.length) {
		console.warn('[leadGenerationFormBlock] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	await Promise.all(
		Array.from(leadGenerationForms).map(async (item, index) => {
			const app = createApp({
				name: `lead-generation-form-block-${index}`,
			});
			app.component('lead-generation-form-block', LeadGenerationFormBlock);
			await initFormKitSchema(app, options);
			app.mount(item);
		}),
	);
}

mountLeadGenerationFormBlock().catch((error) => {
	console.error('Error mounting LeadGenerationFormBlock:', error);
});

